import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["x1", "y1", "x2", "y2"]

import { Link } from "features/links/links";
import { FeatureNode } from "game/layers";
import { computed, toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    link: null,
    startNode: null,
    endNode: null,
    boundingRect: null
  },
  setup(__props: any) {

const _props = __props as {
    link: Link;
    startNode: FeatureNode;
    endNode: FeatureNode;
    boundingRect: DOMRect | undefined;
}


const props = toRefs(_props);

const startPosition = computed(() => {
    const rect = props.startNode.value.rect;
    const boundingRect = props.boundingRect.value;
    const position = boundingRect
        ? {
              x: rect.x + rect.width / 2 - boundingRect.x,
              y: rect.y + rect.height / 2 - boundingRect.y
          }
        : { x: 0, y: 0 };
    if (props.link.value.offsetStart) {
        position.x += props.link.value.offsetStart.x;
        position.y += props.link.value.offsetStart.y;
    }
    return position;
});

const endPosition = computed(() => {
    const rect = props.endNode.value.rect;
    const boundingRect = props.boundingRect.value;
    const position = boundingRect
        ? {
              x: rect.x + rect.width / 2 - boundingRect.x,
              y: rect.y + rect.height / 2 - boundingRect.y
          }
        : { x: 0, y: 0 };
    if (props.link.value.offsetEnd) {
        position.x += props.link.value.offsetEnd.x;
        position.y += props.link.value.offsetEnd.y;
    }
    return position;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("line", _mergeProps({
    "stroke-width": "15px",
    stroke: "white"
  }, __props.link, {
    x1: _unref(startPosition).x,
    y1: _unref(startPosition).y,
    x2: _unref(endPosition).x,
    y2: _unref(endPosition).y
  }), null, 16, _hoisted_1))
}
}

})